import { Link } from 'react-router-dom';
import { CalendarDays, Users, RefreshCw } from 'lucide-react';
import { usePlans } from '@/lib/queries';
import { money } from '@/lib/format';
import { useAuth } from '@/lib/auth';

export function Landing() {
  const { session } = useAuth();
  const plans = usePlans();
  return (
    <div className="space-y-10">
      <section className="relative overflow-hidden border border-stone-200 bg-white px-6 py-12 sm:px-12">
        <span aria-hidden="true" className="pointer-events-none absolute -right-6 -top-10 select-none font-jp text-[220px] font-extrabold leading-none text-ink-900 opacity-[0.04]">剛柔</span>
        <p className="eyebrow relative">English Goju-Ryu Karate-do Association</p>
        <h1 className="relative mt-3 max-w-xl text-4xl leading-tight sm:text-5xl">Your EGKA membership, in one place</h1>
        <p className="relative mt-4 max-w-xl text-lg text-ink-700">
          Join or renew your annual membership, manage your family's details, and book gradings, courses and Gasshuku.
        </p>
        <div className="relative mt-8 flex flex-wrap gap-3">
          <Link to={session ? '/home' : '/signin'} className="btn-primary">{session ? 'Go to my household' : 'Sign in or join'}</Link>
          <Link to="/events" className="btn border border-ink-900 text-ink-900 hover:bg-stone-100">See upcoming events</Link>
        </div>
      </section>

      <section className="grid gap-4 sm:grid-cols-3">
        {[
          { icon: RefreshCw, title: 'Renew in a minute', body: 'Pay by Direct Debit and your membership renews itself each year, or pay once by bank.' },
          { icon: Users, title: 'One account per family', body: 'Add your children and partner. One login looks after everyone at your address.' },
          { icon: CalendarDays, title: 'Book events', body: 'Gradings, courses and Gasshuku, with the right price for each age group.' },
        ].map(({ icon: Icon, title, body }) => (
          <div key={title} className="card">
            <Icon className="text-brand-600" size={22} strokeWidth={1.75} />
            <h2 className="mt-3 text-xl">{title}</h2>
            <p className="mt-1 text-sm text-ink-500">{body}</p>
          </div>
        ))}
      </section>

      <section>
        <h2 className="text-2xl">Membership fees</h2>
        <p className="mt-1 text-sm text-ink-500">Annual. Includes insurance when training at an EGKA dojo or event under a recognised instructor.</p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {(plans.data ?? []).map(p => (
            <div key={p.id} className="card">
              <p className="text-sm text-ink-500">{p.name}</p>
              <p className="mt-1 font-display text-3xl font-bold">{money(p.price_pence)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
